import { SolicitacaoDetalhada } from "model/solicitacao/SolicitacaoDetalhada"
import { ApiAxios } from "../ApiAxios"
import { Api } from "service/api/Api";
import { QueryParamsFormatter } from "service/QueryParamsFormatter";

import { SolicitacaoResumida } from "model/solicitacao/SolicitacaoResumida";
import { Page } from "model/Page";
import { OrdemColunaTabela } from "view/component/Tabela/model/OrdemColunaTabela";
import { CriacaoComentarioDTO } from "model/solicitacao/comentario/CriacaoComentarioDTO";
import { SolicitacaoReaberta } from "model/solicitacao/reabertura/SolicitacaoReaberta";


export interface SolicitacoesQueryParams {
  page?: number

  id?: number[]
  titulo?: string
  descricao?: string
  solucao?: string
  idSituacao?: number[]
  idPrioridadeSolicitacao?: number[]
  idUnidadeResponsavel?: number[]

  idCriador?: string[]
  idSolicitante?:string[]
  idResponsavelTecnico?: number[];
  idClassificacao?: string[]
  idInteressado?: string[]

  dataCriacaoInicio?: string
  dataCriacaoFim?: string
  dataAtualizacao?: string
}


export class ApiSolicitacoes {

  static async novaSolicitacao(solicitacao: SolicitacaoDetalhada): Promise<SolicitacaoDetalhada> {
    const response = await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/solicitacoes`, solicitacao)
    return response.data
  }

  static async getSolicitacao(id: number): Promise<SolicitacaoDetalhada> {
    const response = await ApiAxios.instance.get(`/reinos/${Api.REINO_PADRAO}/solicitacoes/${id}`)
    return response.data
  }

  static async editarSolicitacao(id: number, solicitacao: any): Promise<SolicitacaoDetalhada> {
    const response = await ApiAxios.instance.patch(`/reinos/${Api.REINO_PADRAO}/solicitacoes/${id}`, solicitacao)
    return response.data
  }

  static async getSolicitacoes(page: number, ordem?: OrdemColunaTabela, query?: SolicitacoesQueryParams): Promise<Page<SolicitacaoResumida>> {
    const paginaSpringBoot = Api.pageConvertion(page)
    
    const queryParams = QueryParamsFormatter.format(query ?? {});
    const pageParams = `page=${paginaSpringBoot}&size=20`;
    const sortParams = Api.ordemToApi(ordem);

    const url = `/reinos/${Api.REINO_PADRAO}/solicitacoes?${pageParams}&${queryParams}&${sortParams}`;
    const response = await ApiAxios.instance.get(url);
    return response.data;
  }

  static async reabrirSolicitacao(idSolicitacao: number, comentario: CriacaoComentarioDTO): Promise<SolicitacaoReaberta> {
    const response = await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/solicitacoes/${idSolicitacao}/reabrir`, comentario)
    return response.data
  }
}
